function TermsOfService(props) {
    return (
        <div style={{ width: "50%", margin: "auto" }}>
            <p class="c4">
                <span class="c2 c5">Website Terms of Use</span>
            </p>
            <p class="c4">
                <span class="c2 c5">Last revised on February 16, 2023</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">1. INTRODUCTION; ACCEPTANCE OF TERMS;
                    MODIFICATIONS THERETO.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(a) These Terms of Service
                    (&ldquo;TOS&rdquo;), together with the Tag Tech Services Agreement
                    (the &ldquo;Agreement&rdquo;) sets out the terms under which Tag Tech
                    LLC (&ldquo;Tag Tech&rdquo;) will provide the User with document
                    scanning, storage and management services. Such services, including,
                    without limitation, use of the Tag Tech website (&ldquo;Site&rdquo;)
                    and software, are referred to herein collectively as the &ldquo;Tag
                    Tech Services.&rdquo; Persons who have entered into an Agreement with
                    Tag Tech are sometimes referred to in these TOS as the
                    &ldquo;User.&rdquo;</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(b) These TOS govern the Tag Tech Services and
                    supersede and replace any prior Terms of Service applicable to the
                    Tag Tech Services. The most recent version of the TOS is available at
                    https://app.gotagtech.com/ or at such other address as Tag Tech may
                    designate from time to time.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(c) Tag Tech reserves the right at any time to
                    update, amend or restate these TOS, and without notice to or the
                    consent of User, provided, however, that Tag Tech will use reasonable
                    efforts to give Users ten (10) days prior notice of any such updates,
                    amendments or restatements, and thereafter offer Users the
                    opportunity to accept or reject such changes through a click-wrap or
                    click-through interface. Acceptance of changes to the TOS are a
                    requirement to continued use of the Tag Tech Services.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">2. OWNERSHIP AND CONFIDENTIALITY.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">Tag Tech is the sole and exclusive owner of
                    all right, title, and interest in the Tag Tech Services, including,
                    without limitation, trademarks, copyrights, patents, trade names,
                    trade secrets, and intellectual property rights in the name Tag Tech
                    and the service mark Tag Tech. User shall not claim any ownership
                    rights in any intellectual property of Tag Tech.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">Confidential Information.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(a) All non-public, confidential or
                    proprietary information of Tag Tech, including, without limitation,
                    trade secrets, technology, information pertaining to business
                    operations and strategies, and information pertaining to customers,
                    pricing, and marketing (collectively, &ldquo;Confidential
                    Information&rdquo;), disclosed by Tag Tech to User, whether disclosed
                    orally or disclosed or accessed in written, electronic or other form
                    or media, and whether or not marked, designated or otherwise
                    identified as &ldquo;confidential,&rdquo; in connection with the
                    provision of the Tag Tech Services, the Agreement or these TOS, is
                    confidential, and shall not be disclosed or copied by User without
                    the prior written consent of Tag Tech. Confidential Information does
                    not include information that is: (i) in the public domain; (ii) known
                    to User at the time of disclosure; or (iii) rightfully obtained by
                    User on a non-confidential basis from a third party that is in
                    rightful possession of such information.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(b) Customer agrees to use the Confidential
                    Information only to make use of the Tag Tech Services and for no
                    other use.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(c) Tag Tech shall be entitled to injunctive
                    relief for any violation of this Section.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">3. USER&rsquo;S REPRESENTATIONS AND
                    WARRANTIES.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User represents and warrants to Tag Tech that
                    (a) User had all corporate, company or other authority required to
                    enter into the Agreement and the individual(s) who executed the
                    Agreement and who accepted these TOS on behalf of User was authorized
                    to do so, (b) User is familiar with and is solely responsible for
                    User&rsquo;s compliance with all federal, state, provincial, or local
                    laws regarding data security (collectively, &ldquo;Laws&rdquo;),
                    applicable to its business, to its use of the Tag Tech Services, or
                    User&rsquo;s activities in connection therewith, (c) User has
                    implemented and will maintain reasonable security procedures and
                    practices to protect all personal information from unauthorized
                    access, destruction, use, modification or disclosure. User will
                    comply with all Laws, whether now existing or hereafter enacted,
                    relating to security of personal information and/or data, data
                    breaches and/or privacy (collectively, &ldquo;Data Breach
                    Laws&rdquo;), (d) User will immediately notify Tag Tech if User
                    becomes aware that any unlawful or unauthorized acquisition of
                    computerized data or other security breach with respect to the Site
                    or any business records, documents, information or data uploaded to
                    the Site has occurred or may have occurred, and (e) User will remit
                    all amounts owed to Tag Tech pursuant to these TOS and the Agreement
                    (including any Taxes) as required hereunder and thereunder.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">4. CHANGES TO THE TAG TECH SERVICES.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">Tag Tech reserves the right at any time to
                    revise and modify the Tag Tech Services and/or the Site, and to alter
                    features, specifications, capabilities, functions, and other
                    characteristics of the same, without notice to or the consent of
                    User, provided, however, that Tag Tech will use reasonable efforts to
                    give Users ten (10) days prior notice of any such updates, amendments
                    or restatements. If any such action materially and adversely affects
                    the benefits User might reasonably be expected to obtain from the Tag
                    Tech Services or the Site, User&#39;s sole and exclusive remedy shall
                    be to give Tag Tech notice of termination specifying the basis
                    therefore in reasonable detail, which termination shall be effective
                    thirty (30) days after it is given, unless, prior to the expiration
                    of such thirty (30) day period, (a) Tag Tech and User reach an
                    agreement for a remediation of the issue in writing or (b) Tag Tech
                    modifies the Tag Tech Services and/or the Site to restore the
                    benefits.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">5. USE OF THE TAG TECH SERVICES.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">In connection with the use of the Tag Tech
                    Services and the Site, User agrees as follows:</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(a) The person signing the Agreement on behalf
                    of User hereby affirms that such person has all requisite power and
                    authority to execute the Agreement for and on behalf of User and to
                    bind User to the terms of these TOS, the Agreement and all other
                    obligations thereunder and hereunder. Upon execution of the Agreement
                    by User and Tag Tech, these TOS and the Agreement shall be valid and
                    binding obligations on User and Tag Tech.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(b) User agrees to keep its login(s),
                    password(s) and account number confidential, to use effective ones
                    that are not easily guessed or discoverable, to allow no other person
                    to use the same, and to notify Tag Tech promptly if User has any
                    reason to believe that any third party has unauthorized access to
                    User&rsquo;s account or has otherwise gained unauthorized access to
                    the Site. User is responsible for any and all use of the Tag Tech
                    Services or the Site occurring under User&rsquo;s login(s) or account
                    number, whether authorized or unauthorized.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(c) Certain document scanning software created
                    by Dynamsoft is available for download and use by User (if desired by
                    User) in connection with the Tag Tech Services, and in connection
                    therewith User hereby acknowledges and agrees that, subject to and
                    conditioned on User&rsquo;s compliance with the terms and conditions
                    of these TOS and the Agreement:</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User is hereby granted a non-exclusive,
                    non-sublicensable, and non-transferable limited license during the
                    term of the Agreement to use such software and the Tag Tech Services
                    solely for User&rsquo;s internal business purposes in accordance with
                    the Agreement and these TOS;</span>
            </p>
            <p class="c3">
                <span class="c0">User will not use such software or the Tag
                    Tech Services for any purposes beyond the scope of the license
                    granted in the Agreement and these TOS and, without limiting the
                    foregoing, User shall not at any time, directly or indirectly: (A)
                    copy, modify, or create derivative works from such software, in whole
                    or in part; (B) rent, lease, lend, sell, sublicense, assign,
                    distribute, publish, transfer, or otherwise make available such
                    software; (C) reverse engineer, disassemble, decompile, decode, adapt
                    or otherwise attempt to derive or gain access to the source code of
                    such software, in whole or in part; (D) remove any proprietary
                    notices from such software; or (E) use such software in any manner or
                    for any purpose that infringes, misappropriates or otherwise violates
                    any intellectual property right or other right of any person, or that
                    violates any applicable Law;</span>
            </p>
            <p class="c3">
                <span class="c0">Tag Tech reserves all rights not expressly
                    granted to User in these TOS or the Agreement and, except as
                    expressly set forth herein, nothing in these TOS or the Agreement
                    grants, by implication, waiver, estoppel, or otherwise, to User or
                    any third party any intellectual property rights or other right,
                    title, or interest in or to such software; and</span>
            </p>
            <p class="c3">
                <span class="c0">User is responsible and liable for all uses of
                    such software resulting from access provided by User, directly or
                    indirectly, whether such access or use is permitted by or in
                    violation of these TOS or the Agreement.</span>
            </p>
            <p class="c3">
                <span class="c0">(d) User will not use third-party software to
                    access Tag Tech software or the Tag Tech Services unless expressly
                    approved in writing by Tag Tech in advance.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(e) User shall use the Tag Tech Services only
                    to upload and store business records of the User and will not upload
                    any documents that are obscene or illegal or to which it does not
                    have a right to access, use and store. User shall not upload and
                    store business records of any other business entity besides User (as
                    contemplated by the Agreement) without the prior written consent of
                    Tag Tech.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(f) User shall be solely responsible for
                    complying with all rules, Laws and regulations applicable to its
                    business, including, without limitation, Laws pertaining to the
                    retention of documents.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(g) User will cooperate with Tag Tech as Tag
                    Tech deems reasonably necessary to comply with any Laws, including,
                    without limitation, notifying any persons whose personal information
                    may have been accessed, disclosed, used or otherwise affected by a
                    security breach. Unless the security breach was the direct result of
                    Tag Tech&rsquo;s gross negligence or willful misconduct, User will
                    reimburse Tag Tech for all of its costs and expenses, including,
                    without limitation, attorney fees, associated with the security
                    breach and will, at User&rsquo;s sole cost and expense, take such
                    actions as Tag Tech may require to comply with Laws in the event of a
                    security breach.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">6. MAINTENANCE.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User acknowledges that the Tag Tech Services
                    may be unavailable from time to time to resolve technical problems,
                    to upgrade software, or to otherwise ensure safe and efficient
                    delivery of the Tag Tech Services. Service interruptions may also
                    occur due to power interruptions, problems with service providers
                    subcontracted by Tag Tech, or other conditions beyond Tag
                    Tech&rsquo;s control. User waives any and all claims against Tag Tech
                    arising from any of the foregoing. Tag Tech will use reasonable
                    efforts to minimize the time during which the Tag Tech Services are
                    unavailable for such reasons. User may be entitled to deduct a
                    reasonable, proportionate amount from its monthly dues for
                    unavailability extending beyond 24 consecutive hours, unless caused
                    by, or resulting from, cuts or circumstances beyond the reasonable
                    control of Tag Tech.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">7. INCREASED MONTHLY FEE.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">Within ninety (90) days of the commencement of
                    any renewal term under the Agreement or once every twelve (12) months
                    of the Term, Tag Tech may elect by written notice to User to increase
                    the monthly fee payable by User by up to five percent (5%) over the
                    monthly fee in effect immediately prior to such renewal term.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">8. LATE FEE.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">If any fee for Tag Tech Services or other
                    amount owed hereunder remains delinquent ten (10) days after its
                    invoice due date, User shall be assessed an additional late fee of
                    five percent (5%) of the delinquent amount (subject to a minimum of
                    $35) for each month of delinquency, without waiving Tag Tech&rsquo;s
                    other rights and remedies under the Agreement or these TOS. The above
                    late fees represent Tag Tech&rsquo;s estimate of its reasonable
                    damages incurred in connection with late payments and are in addition
                    to Tag Tech&rsquo;s other rights and remedies.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">9. TERMINATION.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">Tag Tech may terminate User&rsquo;s access to
                    the Tag Tech Services and the Agreement and accelerate all amounts
                    owed by User to Tag Tech for the then-remaining Term if User: (a)
                    fails to pay any amount when due under the Agreement and this TOS;
                    (b) has not otherwise performed or complied with any of the terms of
                    the Agreement or this TOS, in whole or in part; or (c) becomes
                    insolvent, files a petition for bankruptcy or commences or has
                    commenced against it proceedings relating to bankruptcy,
                    receivership, reorganization or assignment for the benefit of
                    creditors. Termination of this Agreement shall not affect the
                    parties&rsquo; obligations hereunder arising prior to the effective
                    date of the termination.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">10. INDEMNIFICATION.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User shall indemnify and hold harmless Tag
                    Tech, its stockholders, board of directors, officers, agents,
                    employees and independent contractors (including, without limitation,
                    any Site hosts), successors and assigns from and against any and all
                    claims, demands, liabilities, losses, fines, costs, expenses
                    (including, without limitation, attorney fees whether before, during
                    or at trial or in any other proceedings, negotiations or otherwise,
                    on appeal or in any bankruptcy proceeding) and damages directly or
                    indirectly arising out of or related to (a) the breach of any
                    representation, warranty or covenant by User under the Agreement or
                    these TOS, (b) the failure of User, its employees or agents to comply
                    with any Laws, including, without limitation, Data Breach Laws, and
                    (c) the use or misuse by User, its employees or agents of the Tag
                    Tech Services or the Site.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">11. DISCLAIMER OF WARRANTIES; LIMITATION OF
                    LIABILITY.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User understands and agrees that, except as
                    expressly set forth herein or in the Agreement, the Tag Tech Services
                    are provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo;
                    basis without warranties or conditions of any kind, neither express
                    nor implied, including, without limitation, warranties or conditions
                    of merchantability, fitness for a particular purpose, or
                    non-infringement. Tag Tech makes no representations or warranties
                    that the User&#39;s use of the Tag Tech Services will comply with
                    applicable Laws. The User acknowledges that it is the User&#39;s sole
                    responsibility to ensure such compliance. TAG TECH, ITS MEMBERS,
                    BOARD OF DIRECTORS, OFFICERS, EMPLOYEES AND INDEPENDENT CONTRACTORS
                    (INCLUDING, WITHOUT LIMITATION, SITE HOSTS) AND THEIR SUCCESSORS AND
                    ASSIGNS SHALL NOT BE LIABLE FOR ANY LOSS OF BUSINESS, PROFITS OR
                    GOODWILL, FOR LOSS OR CORRUPTION OF DOCUMENTS, FILES OR DATA STORED
                    AT THE SITE, FOR INTERRUPTION OF BUSINESS, OR FOR ANY INDIRECT,
                    SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES OF ANY NATURE,
                    ARISING FROM ANY CIRCUMSTANCES OR LEGAL THEORIES WHATSOEVER, EVEN IF
                    AWARE OF THE RISK OF SUCH DAMAGES, RESULTING IN ANY WAY FROM
                    USER&rsquo;S USE OF OR INABILITY TO USE THE SITE OR THE TAG TECH
                    SERVICES. THE TOTAL LIABILITY OF TAG TECH FOR ANY REASON UNDER ANY
                    LEGAL THEORY SHALL NOT EXCEED THE AMOUNT PAID BY USER TO TAG TECH
                    DURING THE PREVIOUS TWELVE-MONTH PERIOD.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">The parties acknowledge that Tag Tech has set
                    its prices and entered into this Agreement in reliance on the
                    limitations of liability and disclaimers of warranties and damages
                    set forth herein, and that the same form a fundamental and essential
                    basis of the bargain between the parties.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">12. TAXES.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">User is responsible for payment of any and all
                    sales, use, excise and any other taxes, duties and charges of any
                    kind or nature (collectively, &ldquo;Taxes&rdquo;) imposed by any
                    federal, state, provincial, local or foreign governmental entity on
                    any amounts payable by User under the Agreement or these TOS, but
                    excluding any Taxes due on Tag Tech&rsquo;s income or gross receipts,
                    which shall be the responsibility of Tag Tech. Notwithstanding the
                    foregoing, if Tag Tech (in its reasonable discretion) has a legal
                    obligation to pay or collect Taxes for which User is responsible
                    under this section, the amount of such Taxes shall be invoiced to
                    User and paid to Tag Tech by User within thirty (30) days (or such
                    other time period set forth in the invoice issued to User by Tag
                    Tech) unless User provides Tag Tech with a valid tax exemption
                    certificate authorized by the appropriate taxing authority or such
                    other documentation as Tag Tech may reasonably request.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">13. PRIVACY AND SECURITY.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(a) Tag Tech abides by applicable privacy laws
                    and its Privacy Policy.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(b) Tag Tech will not use, disclose or retain
                    Personal Information in any way except pursuant to User instructions
                    or to the extent necessary to perform the services under this
                    Agreement.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(c) Tag Tech uses various security measures to
                    prevent the unauthorized use and disclosure of Personal Information.
                    Details are available on request.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(d) Tag Tech will promptly notify the User of
                    any requests for disclosure of Personal Information relating to
                    User&rsquo;s use of the Tag Tech Services by any party and of any
                    accidental or unauthorized access to such information.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(e) Tag Tech will promptly notify the User of
                    any actual or suspected breach of security affecting Personal
                    Information relating to User&rsquo;s use of the Tag Tech Services and
                    cooperate with User so User can comply with any relevant breach
                    notification obligations.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(f) Tag Tech agrees to take commercially
                    reasonable actions to prevent disclosure of or access to User
                    Information and will not disclose such User Information to any third
                    party without the written consent of User; provided, however, that
                    notwithstanding the foregoing, Tag Tech may disclose (without any
                    obligation to do so under the Agreement) such User Information as Tag
                    Tech determines is necessary: (i) to comply with any Laws; (ii) to
                    perform its obligations under or to enforce the Agreement; (iii) to
                    respond to claims that Tag Tech or User is engaged (through the Site
                    or otherwise) in activities that violate the rights of third parties
                    or violate any Laws.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">14. OTHER LEGAL PROVISIONS.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(a) The provisions of this section and
                    Sections 9-12 shall survive any termination or expiration of the
                    Agreement and these TOS.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(b) No agency relationship, partnership or
                    joint venture is created nor intended to be created by the Agreement
                    or TOS or the granting of rights to User hereunder.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(c) Neither the Agreement, these TOS nor any
                    of the rights, interests or obligations under the Agreement or these
                    TOS shall be assigned, in whole or in part, by operation of law or
                    otherwise, by either party without the prior written consent of the
                    other party. Notwithstanding the foregoing, either party may assign
                    the Agreement and these TOS upon written notice to the other party to
                    an entity that acquires all or substantially all of the equity
                    interests or assets of such party, whether by merger, reorganization,
                    acquisition, sale or otherwise. Any purported assignment in violation
                    of this provision shall be null and void.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(d) Except as otherwise expressly provided in
                    the Agreement or TOS, all notices or other communications required or
                    permitted hereunder shall be in writing and shall be sent by
                    first-class mail (with postage prepaid) or by e-mail and shall be
                    deemed received and effective five (5) days after the date of
                    posting, if mailed, or upon receipt of confirmation of successful
                    sending, if sent by e-mail.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(e) The Agreement and TOS shall be governed by
                    and construed under the laws of the State of Florida (without regard
                    to conflicts of laws principles), and any and all disputes arising
                    under or relating to these TOS or the Agreement shall be resolved by
                    binding arbitration in Pensacola, Florida under the auspices of the
                    American Arbitration Association. User consents in advance to such
                    jurisdiction and venue and waives any objection it may have based
                    upon lack of personal jurisdiction, improper venue or forum non
                    conveniens.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(f) The Agreement and TOS set forth the entire
                    agreement and understanding of the parties and supersede all prior
                    agreements and understandings relating to the subject matter hereof.
                    No modification of the Agreement and TOS offered by User shall become
                    binding unless documented in a writing signed by User and Tag Tech.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(g) If any provision of the Agreement or TOS
                    is held to be invalid, such event shall not affect, in any respect
                    whatsoever, the validity of the remainder of the Agreement or TOS,
                    and the remainder shall be construed without the invalid provision so
                    as to carry out the intent of the parties to the extent possible
                    without the invalid provision.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(h) Tag Tech&rsquo;s failure to insist upon or
                    enforce strict performance of any provision of the Agreement or TOS
                    shall not be construed as a waiver of any provision or right, nor
                    shall the course of conduct between the parties modify any provision
                    of the Agreement or TOS.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(i) Neither party shall be liable to the other
                    for any delay or failure in performance under the Agreement or TOS
                    resulting directly or indirectly from acts of nature or causes beyond
                    its reasonable control.</span>
            </p>
            <p class="c1">
                <span class="c0"></span>
            </p>
            <p class="c3">
                <span class="c0">(j) If any party hereto brings an action or proceeding
                    for the declaration of the rights of the parties hereunder, for
                    injunctive relief or for an alleged breach or default of, or any
                    other action arising out of the Agreement or TOS, the prevailing
                    party in any such action shall be entitled to an award of reasonable
                    attorneys&rsquo; fees and any court costs incurred in such action or
                    proceeding in addition to any other damages or relief awarded,
                    regardless of whether such action proceeds to final judgment.</span>
            </p>
            <div>
                <p class="c3">
                    <span class="c0">&nbsp;</span>
                </p>
            </div>

        </div>
    );
};

export { TermsOfService }